export default __webpack_public_path__ + "static/media/yellow convert.dc74e9fb.svg";